import { refreshSelectMenu } from '../../shared/ts/select-menu/select-menu-refresh'

function updateRelatedDropdown(relatedDropdown, visibleOptions) {
  relatedDropdown.querySelectorAll('option').forEach((option) => {
    // type of values in visibleOptions[] is int, but in dropdown string, so for comparison parse option to int
    const optionValue = parseInt(option.value)
    if (!!visibleOptions && visibleOptions.includes(optionValue)) {
      option.classList.remove('hidden')
      option.disabled = false
    } else {
      option.classList.add('hidden')
      option.disabled = true
    }
  })

  refreshSelectMenu(relatedDropdown)
}

export default function ConditionalDropdowns(conditionalDropdown) {
  const conditionsJSON = JSON.parse(conditionalDropdown.dataset.dropdownConditions)
  const select1 = conditionalDropdown.querySelector('.dropdown--first-condition select')
  const select2 = conditionalDropdown.querySelector('.dropdown--second-condition select')

  select1.addEventListener('change', () => {
    updateRelatedDropdown(select2, conditionsJSON.dropdown1[select1.value])
  })

  select2.addEventListener('change', () => {
    updateRelatedDropdown(select1, conditionsJSON.dropdown2[select2.value])
  })
}
